// region-availability.js
// Controls the "Customize" button and region message based on the selected variant.

document.addEventListener('DOMContentLoaded', function () {
    // Handle all product-info sections on the page
    var productInfos = document.querySelectorAll('product-info[data-product-id]');

    productInfos.forEach(function (sectionEl) {
      var productId = sectionEl.getAttribute('data-product-id');
      if (!productId) return;

      // Read the JSON map injected by Liquid for this product
      var mapScript = document.getElementById('RegionVariantMap-' + productId);
      if (!mapScript) return;

      var mapData;
      try {
        mapData = JSON.parse(mapScript.textContent);
      } catch (e) {
        console.error('RegionVariantMap JSON parse error', e);
        return;
      }

      // Build a map: variantId -> region_allowed (true/false)
      var variantMap = {};
      (mapData.variants || []).forEach(function (v) {
        variantMap[String(v.id)] = !!v.region_allowed;
      });

      /**
       * Apply region logic to the current variant:
       * - Disable "Customize" and show message if not allowed in this region
       * - Otherwise hide the message and respect real availability/stock
       */
      function setRegionState(variantId, isSoldOut) {
        if (!variantId) return;

        // Always re-query the current button and message in case the form was re-rendered
        var buyButton = sectionEl.querySelector('[data-region-buy-button]');
        var messageEl = sectionEl.querySelector('[data-region-unavailable-message]');

        if (!buyButton || !messageEl) return;

        var allowed = true;
        if (Object.prototype.hasOwnProperty.call(variantMap, variantId)) {
          allowed = variantMap[variantId];
        }

        if (!allowed) {
          // Variant is not available in this region
          buyButton.disabled = true;
          messageEl.style.display = 'block';
        } else {
          // Variant is allowed in this region
          messageEl.style.display = 'none';

          // Respect real stock: only enable if not sold out
          if (!isSoldOut) {
            buyButton.disabled = false;
          } else {
            buyButton.disabled = true;
          }
        }
      }

      /**
       * Helper to read the current variant from the hidden input
       * created by Shopify's product form.
       */
      function readVariantFromInput() {
        var input = sectionEl.querySelector('input.product-variant-id');
        if (!input) return null;

        return {
          id: String(input.value || ''),
          // Shopify disables the input when the variant cannot be purchased
          isSoldOut: input.disabled === true
        };
      }

      // --- 1) Initial state ---
      var current = readVariantFromInput();
      if (current && current.id) {
        setRegionState(current.id, current.isSoldOut);
      }

      // --- 2) Listen to Shopify variant change events (Dawn / Online Store 2.0 themes) ---
      ['variant:change', 'variant:changed'].forEach(function (eventName) {
        sectionEl.addEventListener(eventName, function (e) {
          var detail = e.detail || {};
          var variant = detail.variant || detail.selectedVariant || null;

          if (variant) {
            // Use variant data from the event if available
            setRegionState(String(variant.id), !variant.available);
          } else {
            // Fallback: read from the hidden input
            var c = readVariantFromInput();
            if (c && c.id) {
              setRegionState(c.id, c.isSoldOut);
            }
          }
        });
      });

      // --- 3) Safety net: poll for changes, in case the theme re-renders the form ---
      var lastId = current ? current.id : null;
      var lastSoldOut = current ? current.isSoldOut : null;

      setInterval(function () {
        var c = readVariantFromInput();
        if (!c || !c.id) return;

        // Only update when something actually changed
        if (c.id !== lastId || c.isSoldOut !== lastSoldOut) {
          lastId = c.id;
          lastSoldOut = c.isSoldOut;
          setRegionState(c.id, c.isSoldOut);
        }
      }, 300); // runs only on the product page, so this is safe
    });
  });
